import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Header,
  Divider,
  Table,
  Button,
  Icon,
  Input,
  Message,
  Loader
} from "semantic-ui-react";
import { formatDate, decodeEntities } from "../../../common/utils/format";

/**
 * 보관함 — 다음에 신청할 도서를 제목만 담아두는 곳.
 * URL/가격은 외부 사이트 데이터라 보관하지 않고, 신청 시 재검색으로 고른다.
 */
const Cart = ({ carts, loading, onAdd, onDelete, onRequest }) => {
  const [name, setName] = useState("");

  const submitAdd = () => {
    const n = name.trim();
    if (!n) return;
    onAdd(n);
    setName("");
  };

  return (
    <Container style={{ padding: "6em 0em", minHeight: "90vh" }}>
      <div style={{ maxWidth: 760, margin: "0 auto" }}>
        <Header as="h2">
          <Icon name="bookmark outline" />
          <Header.Content>
            보관함
            <Header.Subheader>
              나중에 신청할 도서를 담아두는 곳입니다. 판매 링크와 가격은 수시로
              바뀌기 때문에 제목만 보관하고, 신청할 때 다시 검색해서 선택합니다.
            </Header.Subheader>
          </Header.Content>
        </Header>
        <Divider section />

        {/* 도서명 직접 등록 */}
        <div style={{ display: "flex", gap: "0.5em", marginBottom: "1.5em" }}>
          <Input
            style={{ flex: 1 }}
            placeholder="담아둘 도서명을 입력하세요"
            value={name}
            onChange={e => setName(e.target.value)}
            onKeyDown={e => {
              if (e.key === "Enter") submitAdd();
            }}
          />
          <Button primary type="button" disabled={!name.trim()} onClick={submitAdd}>
            <Icon name="plus" />
            담기
          </Button>
        </div>

        {loading ? (
          <Loader active inline="centered" />
        ) : carts.length > 0 ? (
          <Table celled compact unstackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>도서명</Table.HeaderCell>
                <Table.HeaderCell collapsing>담은 날짜</Table.HeaderCell>
                <Table.HeaderCell collapsing textAlign="center" />
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {carts.map(c => (
                <Table.Row key={c.cartSeq}>
                  <Table.Cell>{decodeEntities(c.bookName)}</Table.Cell>
                  <Table.Cell style={{ whiteSpace: "nowrap", color: "#666" }}>
                    {formatDate(c.regDt)}
                  </Table.Cell>
                  <Table.Cell textAlign="center" style={{ whiteSpace: "nowrap" }}>
                    <Button
                      size="tiny"
                      primary
                      type="button"
                      onClick={() => onRequest(c.bookName)}
                    >
                      <Icon name="search" />
                      검색해서 신청
                    </Button>
                    <Button
                      size="tiny"
                      type="button"
                      onClick={() => onDelete(c.cartSeq)}
                    >
                      삭제
                    </Button>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        ) : (
          <Message>
            <Message.Header>보관함이 비어 있습니다</Message.Header>
            <p>
              <Link to="/bookMultiRequest">도서 신청</Link> 화면에서 도서명 옆의
              보관함 버튼으로 담아둘 수 있습니다.
            </p>
          </Message>
        )}
      </div>
    </Container>
  );
};

export default Cart;
